import commonGetters from '@/store/data/common/getters'

const getters = { ...commonGetters }

export default getters
